<template>
  <div class="home">
    <div>
      <Header
        v-bind:pageName="pageName"
        v-bind:login="login"
        v-bind:profile="profile"
        @profile="profile = $event"
        v-bind:mai="mai"
        @mai="mai = $event"
      />
      <Loading v-if="loading" />
      <ChallengesList
        v-bind:challengesList="challengesList"
        v-bind:picked="picked"
        v-bind:uid="user.uid"
        v-bind:uname="profile.name"
        @pickup="picked = $event"
      />
      <AlbumList v-bind:albumsList="albumsList" />
      <CheersList v-bind:uid="user.uid" v-bind:uname="profile.name" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import firebaseUtil from "@/firebase";
import store from "@/store";

import Header from "@/components/modules/header";
import Loading from "@/components/parts/Loading";
import ChallengesList from "@/components/modules/ChallengesList";
import AlbumList from "@/components/modules/AlbumList";
import CheersList from "@/components/modules/CheersList";

export default {
  components: {
    Header,
    Loading,
    ChallengesList,
    AlbumList,
    CheersList,
  },
  data() {
    return {
      pageName: "ホーム",
      login: false,
      user: {},
      provider: {
        twitter: false,
        google: false,
      },
      profile: {},
      mai: {},
      loading: true,
      challengesList: [],
      picked: null,
      albumsList: [],
    };
  },
  created() {
    let myPromise1 = new Promise((resolve) => {
      let page = this.$route.params.userId ? "user" : "none";
      firebaseUtil.onAuth(page).then(() => {
        resolve();
      });
    });
    myPromise1.then(() => {
      this.user = store.getters.user;
      console.log(this.user);
      if (!this.user.state) {
        this.user = "";
      } else {
        for (let i = 0; i < this.user.providerData.length; i++) {
          if (this.user.providerData[i].providerId == "twitter.com") {
            this.provider.twitter = true;
          } else {
            this.provider.google = true;
          }
        }
        this.login = true;
        if (
          !this.$route.params.userId ||
          this.$route.params.userId == this.user.uid
        ) {
          firebaseUtil.getChallengesList(this.user.uid);
          firebaseUtil.getSubscribe(this.user.uid);
        } else {
          firebaseUtil.getChallengesList(this.$route.params.userId);
          firebaseUtil.getSubscribe(this.$route.params.userId);
        }
      }
    });
  },
  computed: {
    profileWatch() {
      return this.profile;
    },
    allListWatch() {
      return store.getters.allList;
    },
  },
  watch: {
    profileWatch() {
      this.loading = false;
    },
    allListWatch(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].data.album) {
          this.albumsList.push(data[i]);
        } else {
          this.challengesList.push(data[i]);
        }
      }
      this.picked = this.challengesList[0];
    },
    $route(to) {
      // ルートの変更の検知...
      firebaseUtil.getChallengesList(to.params.userId);
      firebaseUtil.getSubscribe(to.params.userId);
    },
  },
};
</script>
